import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InBaseFrwComponent} from '../inBaseFrwComponent';
import {Router} from '@angular/router';

@Component({
  selector: 'cmp-sidebar-menu',
  template: `<div class="list-group cursor-pointer {{organization?'calcOrg':'full-height'}}  overflow-auto">
  <ng-template ngFor let-info let-i="index" [ngForOf]="data">
    <a [title]="info.title"
       [class]="classCustom(info)"
       (click)="onClickOption(info, i)">
      <div class="item-sidebar mt-1">
        <img *ngIf="info.typeIcon === enum_type_icon.URL"
             [src]="info.icon" alt="Blueliv"
             height="20">
        <img *ngIf="info.typeIcon === enum_type_icon.IMG"
             [src]="'./assets/images/' + info.icon" alt="Blueliv"
             height="20">
        <i *ngIf="info.typeIcon === enum_type_icon.ICON"
           class="fa {{info.icon}} text-gray"></i>
        <span class="text-uppercase font-weight-normal pl-3">
          {{info.title}}
        </span>
      </div>
      <span class="button-sidebar">
        <cmp-button-icon><i class="fa fa-ellipsis-v"></i></cmp-button-icon>
      </span>

    </a>
    <ul *ngIf="info.children && info.children.length"
        class="sub-menu collapse py-1 pl-3 mb-0"
        [ngbCollapse]=" !childActive(info.children, i)">
      <li *ngFor="let child of info.children"
          class="sub-menu-item p-1"
          [title]="child.title"
          (click)="navigateTo(child.url)"
          style="list-style-type: none;">
        <a [class.active]="activeRoute(child.url)">
          <i class="fa fa-circle"></i>
          <span class="ml-3">{{child.title}}</span>
        </a>
      </li>
    </ul>
  </ng-template>
  <a *ngIf="organization && organization.name"
     [title]="organization.name"
     class="list-group-item border-bottom border-top rounded-0 position-absolute w-100"
     style="bottom: 0"
     (click)="onChangeOrg.emit(null)">
    <div class="item-sidebar mt-1 w-100">
      <i class="fa fa-building "></i>
      <span class=" pl-3">
        {{organization.name}}
      </span>

      <i class="fa fa-arrow-circle-right text-primary pull-right"></i>
    </div>
  </a>
</div>
`,
  styles: [`.list-group-item{padding:8px 15px}.list-group-item .item-sidebar{float:left}.list-group-item .item-sidebar span{color:#1b2734}.list-group-item .button-sidebar{float:right}.list-group-item .button-sidebar .fa{color:#fff}.list-group-item:hover .item-sidebar span{color:#327abd}.list-group-item:hover .button-sidebar .fa{color:#6c757d}.list-group-item.active .item-sidebar span{color:#327abd}.sub-menu{text-transform:capitalize;border-bottom:0;border-left:2px solid #d3d3d3;font-size:14px;margin-left:26px}.sub-menu .sub-menu-item{position:relative;left:-27px;top:0}.sub-menu .sub-menu-item i{color:#d3d3d3}.sub-menu .sub-menu-item span{color:#1b2734}.sub-menu .sub-menu-item a:hover{text-decoration:none}.sub-menu .sub-menu-item a.active i,.sub-menu .sub-menu-item a.active span,.sub-menu .sub-menu-item a:hover i,.sub-menu .sub-menu-item a:hover span{color:#327abd}`]
})
export class SidebarMenuComponent extends InBaseFrwComponent implements OnInit {
  isCollapsed = [false];

  @Input() data = [];
  @Output() optionSelected = new EventEmitter();
  @Output() onNavigate = new EventEmitter();
  @Output() onChangeOrg = new EventEmitter();
  @Input() organization: any;

  constructor(protected router: Router) {
    super();
  }

  ngOnInit() {
  }

  openChild(url, child, o) {
    this.isCollapsed.forEach((e, i) => {
      if (i !== o) {
        this.isCollapsed[i] = false;
      }
    });

    this.isCollapsed[o] = !this.isCollapsed[o];
  }

  navigateTo(opt) {
    this.onNavigate.emit(opt);
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  childActive(childArray, i) {
    let retorno = false;
    if (this.isCollapsed[i]) {
      retorno = true;
    } else {
      retorno = childArray.map(e => e.url).filter(e => this.activeRoute(e) === true).length;
      // if (retorno) {
      //   retorno = !this.isCollapsed.filter(e => e === true).length && retorno;
      // }
    }

    return retorno;
  }

  onClickOption(info, i) {
    if (info.children && info.children.length) {
      this.openChild(info.url, info.children, i);
    } else {
      this.navigateTo(info.url);
    }
  }

  classCustom(info) {
    let retorno = 'list-group-item border-bottom border-top rounded-0 ';
    if (info.children && info.children.length && this.activeRoute(info.url)) {
      retorno += 'active';
    }
    return retorno;
  }
}
